import { useEffect, useState } from 'react';
import { getWorkspacePalette } from '../../../../js/helper';
import { FormattedDate, FormattedMessage } from 'react-intl';
import useNavigateWithPersistedParams from '../../../../js/useNavigateWithPersistedParams';

const ChatsTooltip = (props) => {
  const navigate = useNavigateWithPersistedParams();

  const [chats, setChats] = useState(props.chats);

  useEffect(() => {
    setChats(props.chats);
  }, [props.chats]);

  return (
    <div style={{ background: '#1c1d21', display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
      <header className="flex align-center px-4 py-3 flex-shrink-0" style={{ borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
        <h2 className="font-semibold text-sm" style={{ color: 'rgba(255,255,255,0.85)' }}>
          <FormattedMessage id="RECENT_CHATS" defaultMessage="Recent Chats" />
        </h2>
      </header>
      <div className="py-1.5 overflow-y-auto flex-1">
        <ul>
          {chats?.length > 0 ? chats.map((chat) => {
            const isDirectChat = chat?.roomType === 'direct';
            const isProjectChat = chat?.roomType === 'project';

            const dmUser = chat?.members?.filter(m => m._id !== localStorage.getItem('Id'));
            const name = isDirectChat && !isProjectChat ? dmUser[0]?.fullName : chat.roomName;
            const rawAvi = isDirectChat ? dmUser[0]?.avi : chat.roomAvi;
            const avi = rawAvi?.includes('no_avi.png') ? null : rawAvi;
            const mostRecentMessage = chat.mostRecentMessage || '';

            if (isProjectChat || !name) return null;

            const iconLetters = name?.slice(0, 2)?.toUpperCase() || '';
            const palette = getWorkspacePalette(name);

            let span = document.createElement('span');
            span.innerHTML = mostRecentMessage?.messageDescription;
            const htmlContent = span.textContent || span.innerText;

            const isActive = window?.location?.pathname.includes(chat?._id);

            return (
              <li
                key={chat?._id}
                className="flex align-center gap-3 px-3 py-2.5 cursor-pointer mx-1.5 rounded-lg transition-colors"
                style={{ background: isActive ? 'rgba(255,255,255,0.07)' : '' }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.06)'}
                onMouseLeave={e => e.currentTarget.style.background = isActive ? 'rgba(255,255,255,0.07)' : ''}
                onClick={() => navigate(`/chat/${chat?._id}`)}
              >
                {avi ? (
                  <img src={avi} className='flex-shrink-0 w-8 h-8' alt='icon' style={{ borderRadius: 8, objectFit: 'cover' }} />
                ) : (
                  <div
                    className='flex-shrink-0 flex items-center justify-center w-8 h-8 text-xs font-bold'
                    style={{ borderRadius: 8, background: palette.bg, border: `1px solid ${palette.border}`, color: palette.text, letterSpacing: '0.04em' }}
                  >
                    {iconLetters}
                  </div>
                )}
                <div className="flex-1 min-w-0">
                  <div className="flex justify-between items-center">
                    <span className="text-sm font-medium truncate" style={{ color: 'rgba(255,255,255,0.85)' }}>{name}</span>
                    <span className="text-xs flex-shrink-0 ml-2" style={{ color: 'rgba(255,255,255,0.3)' }}>
                      <FormattedDate value={chat?.lastUpdate} />
                    </span>
                  </div>
                  {htmlContent !== 'undefined' && htmlContent && (
                    <div className="text-xs truncate mt-0.5" style={{ color: 'rgba(255,255,255,0.4)' }}>{htmlContent}</div>
                  )}
                </div>
              </li>
            );
          }) : (
            <li className="px-4 py-3 text-sm" style={{ color: 'rgba(255,255,255,0.4)' }}>
              <FormattedMessage id="NO_CHATS" defaultMessage="No chats" />
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default ChatsTooltip;
